import PropTypes from 'prop-types';

/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

export default function LogoMain({ reverse }) {

  return (
    /**
     * if you want to use image instead of svg uncomment following, and comment out <svg> element.
     *
     * <img src={theme.palette.mode === ThemeMode.DARK ? logoDark : logo} alt="Mantis" width="100" />
     *
     */
     
     <img src="https://stsportsguardianprod001.blob.core.windows.net/adminbackgrounds/Sports_Guardian_Logo_Black.svg" alt="Sports Guardian" width="150" />
  );
}

LogoMain.propTypes = { reverse: PropTypes.bool };
